"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { BrandLogo } from "@/components/marketing/logo";
import { sectionLinks, shell } from "@/components/marketing/shared";

const headerActionClass =
  "inline-flex h-10 shrink-0 items-center justify-center rounded-[10px] border border-[var(--m-line)] bg-white px-3.5 text-sm font-semibold text-[var(--m-ink)] transition-colors hover:bg-[var(--m-soft)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]";

const navLinkClass =
  "text-sm font-medium text-[#3d4b60] transition-colors hover:text-[var(--m-ink)] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--m-accent)]";

function headerAction(pathname: string) {
  if (pathname.startsWith("/register")) {
    return { hint: "Уже есть аккаунт?", href: "/login", label: "Войти" };
  }
  if (pathname.startsWith("/login")) {
    return { hint: "Нет аккаунта?", href: "/register", label: "Создать аккаунт" };
  }
  return { hint: null, href: "/login", label: "Войти" };
}

export function AuthHeader() {
  const pathname = usePathname();
  const action = headerAction(pathname);

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--m-line)] bg-white">
      <div className={`${shell} flex h-16 items-center justify-between gap-4`}>
        <div className="flex min-w-0 items-center gap-8">
          <Link
            href="/"
            className="inline-flex items-center rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--m-accent)]"
          >
            <BrandLogo className="h-7 w-auto" />
          </Link>
          <nav className="hidden items-center gap-7 lg:flex" aria-label="Разделы">
            {sectionLinks.map((link) => (
              <Link key={link.href} href={link.href} className={navLinkClass}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          {action.hint ? (
            <span className="hidden text-sm text-[var(--m-muted)] sm:inline">{action.hint}</span>
          ) : null}
          <Link href={action.href} className={headerActionClass}>
            {action.label}
          </Link>
        </div>
      </div>
    </header>
  );
}
